module.exports = __webpack_public_path__ + "static/media/shape2.ebbc984f.png";